import React from "react";
import { Expand, Radio, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import CrossReverse from "public/cross-reverse.svg";
import ButtonV2 from "elements/ButtonV2";

const VehicleInfo = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const vehicleInfo = React.useMemo(() => {
		return specialFieldsValue?.vehicle_info || [{}];
	}, [specialFieldsValue]);

	const buttonDisabled = React.useMemo(() => {
		if (vehicleInfo[0]?.state_where_owned === undefined) {
			return true;
		} else if (vehicleInfo[0]?.state_where_owned !== "GA") {
			return false;
		} else {
			return (
				!vehicleInfo[0].state_where_registered ||
				vehicleInfo[0].state_where_registered.length < 2 ||
				[
					vehicleInfo[0]?.make,
					vehicleInfo[0]?.model,
					vehicleInfo[0]?.year,
					vehicleInfo[0]?.license_plate_number,
					vehicleInfo[0]?.county_where_registered,
				].some(value => value === undefined || value === "")
			);
		}
	}, [vehicleInfo]);

	const updateVehicleInfo = (
		index: number,
		values: Partial<{
			make: string;
			model: string;
			year: string;
			license_plate_number: string;
			county_where_registered: string;
			state_where_registered: string;
			state_where_owned: string;
		}>
	) => {
		const updatedVehicleInfo = vehicleInfo.map((item, i) => {
			if (i === index) {
				return {
					...item,
					...values,
				};
			}
			return item;
		});
		setSpecialFieldsValue({
			vehicle_info: updatedVehicleInfo,
		});
	};

	const handleSubmit = async () => {
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_VEHICLE_INFO_Answer,
			data: {
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});

		setSpecialFieldsValue({
			vehicle_info: specialFieldsValue?.vehicle_info,
		});
		next();
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>Do you own a vehicle in the state of Georgia?</p>
					<div className="property-profile-question-card-radio">
						<Radio
							checked={vehicleInfo[0]?.state_where_owned === "GA"}
							onChange={e => {
								//@ts-ignore
								const value = e.target.value === "Yes";
								updateVehicleInfo(0, {
									state_where_owned: value ? "GA" : "N/A",
								});
							}}
							value="Yes"
							label="Yes"
						/>
						<Radio
							checked={
								!["GA", undefined].includes(vehicleInfo[0]?.state_where_owned)
							}
							onChange={e => {
								//@ts-ignore
								const value = e.target.value === "Yes";
								updateVehicleInfo(0, { state_where_owned: "N/A" });
							}}
							value="No"
							label="No"
						/>
					</div>
				</div>

				{vehicleInfo[0]?.state_where_owned === "GA" && (
					<>
						<div className="exemptions-input-flex-container">
							<TextField
								required
								label="Make"
								placeholder="Vehicle Make"
								containerClassName="exemptions-card-input"
								value={vehicleInfo[0].make ?? ""}
								maxLength={8}
								onChange={e =>
									updateVehicleInfo(0, {
										make: e.target.value,
									})
								}
							/>
							<TextField
								required
								label="Model"
								placeholder="Vehicle Model"
								containerClassName="exemptions-card-input"
								value={vehicleInfo[0].model ?? ""}
								onChange={e =>
									updateVehicleInfo(0, {
										model: e.target.value,
									})
								}
							/>
						</div>
						<div className="exemptions-input-flex-container">
							<TextField
								required
								label="Year"
								placeholder="Vehicle Year"
								containerClassName="exemptions-card-input"
								value={vehicleInfo[0].year ?? ""}
								maxLength={8}
								onChange={e =>
									updateVehicleInfo(0, {
										year: e.target.value,
									})
								}
							/>
							<TextField
								required
								label="License Plate Number"
								placeholder="License Plate Number"
								containerClassName="exemptions-card-input"
								value={vehicleInfo[0].license_plate_number ?? ""}
								onChange={e =>
									updateVehicleInfo(0, {
										license_plate_number: e.target.value,
									})
								}
							/>
						</div>
						<div className="exemptions-input-flex-container">
							<TextField
								required
								label="County"
								placeholder="County Where Registered"
								containerClassName="exemptions-card-input"
								value={vehicleInfo[0].county_where_registered ?? ""}
								maxLength={8}
								onChange={e =>
									updateVehicleInfo(0, {
										county_where_registered: e.target.value,
									})
								}
							/>
							<TextField
								required
								label="State"
								placeholder="State Where Registered"
								containerClassName="exemptions-card-input"
								value={vehicleInfo[0].state_where_registered ?? ""}
								onChange={e =>
									updateVehicleInfo(0, {
										state_where_registered: e.target.value,
									})
								}
							/>
						</div>
					</>
				)}
			</div>
			<ButtonV2 size="large" disabled={buttonDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default VehicleInfo;
